import React from 'react';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import Button from '../../../../ui-kit/Button';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import useInputState from '../../../../hooks/useInputState';
import Input from '../../../../ui-kit/Input';
import { closeModalAtom } from '../../../../atoms/modalAtoms';
import getProjectNameApiError from '../../../../helpers/getProjectNameApiError';

function RenameProjectModal({ project, onSave }) {
  const { t } = useTranslations();
  const [, closeModal] = useAtom(closeModalAtom);
  const [name, setName, nameError, setNameError] = useInputState(project?.name || '');

  const onSaveClick = async () => {
    const trimmedName = name.trim();
    if (trimmedName.length < 2) {
      setNameError(t(DICTIONARY.minimum2symbols));
      return;
    }

    const data = await onSave({ id: project.id, name: trimmedName });
    const apiError = getProjectNameApiError(data);
    if (apiError) {
      setNameError(apiError);
      return;
    }

    if (data?.status === 'ok') closeModal();
  };

  return (
    <div className={styles.renameProjectModal}>
      <p className={styles.title}>{t(DICTIONARY.renameProject)}</p>
      <div className={styles.field}>
        {nameError ? <p className={styles.error}>{nameError}</p> : null}
        <Input
          value={name}
          onChange={setName}
          placeholder={t(DICTIONARY.projectName)}
          width="100%"
          spellCheck={false}
          error={nameError ? 'NO_ERROR_TEXT' : undefined}
        />
      </div>
      <div className={styles.buttons}>
        <Button width="100%" text={t(DICTIONARY.save)} onClick={onSaveClick} />
      </div>
    </div>
  );
}

export default RenameProjectModal;
